<div class="modal-signup modal-content border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-3px border-bottom padding-right-7px padding-left-8px padding-top-3px">

        <div class="row">
          <div class="col-md-10">
            <label class="margin-bottom-0px">
              Add/Edit OP Services
            </label>
          </div>
            <div class="col-md-2 float-right text-align-right">

              <button type="button" class="close float-right" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>

            </div>     
        

        </div>      
        

      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-3px">
        <div class="row font-size-12px">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-5   padding-right-5px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Patient Name </label>
              </div>:
              <div class="col-md-5 padding-right-0px padding-left-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{OPService.PatientName}}</label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4  text-align-right padding-right-5px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Branch </label>
              </div>:
              <div class="col-md-7 padding-right-0px padding-left-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{OPService.BranchName}}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="row font-size-12px">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-5   padding-right-5px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Formatted Code </label>
              </div>:
              <div class="col-md-5 padding-right-0px padding-left-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{OPService.PatientFormattedCode}}</label>
              </div>
            </div>
          </div>
          
        </div>

        
        <form class="form" novalidate=""  #f="ngForm">
          <div class="modal-body padding-top-0px">
            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">
                <div class="row margin-top-3px">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                    <div class="row margin-bottom-3px">
                      <div class="col-md-5 text-align-right padding-left-0px">
                        <label for="firstName" class="margin-bottom-0px margin-top-3px">Service Description</label>
                      </div>:
                      <div class="col-md-5">
                        <h4 class="margin-bottom-0px margin-top-3px color-item font-weight-bold font-size-16px">{{OPService.ServiceName}}</h4>                        
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right padding-left-0px margin-top-3px">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Date</label>
                      </div>
                      <div class="col-md-5 padding-right-0px">

                        <div class="date-form margin-top-5px form-group margin-bottom-0px">
                          <input class="form-control" placeholder="Service Date" [minDate]="OPService.ServiceDate" 
                                  name="UpdatedServiceDate" [(ngModel)]="UpdatedServiceDate" ngbDatepicker #d="ngbDatepicker">

                          <a (click)="d.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>                        
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right padding-left-0px margin-top-3px">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Provider</label>
                      </div>
                      <div class="col-md-5 padding-right-0px margin-top-3px">
                        <select class="form-control padding-left-0px padding-right-0px" (change)="onChange($event.target)">
                          <option selected="selected" value=""></option>
                          <option *ngFor="let l of CurrentDoctorsListController" [value]="l.ProviderCode">
                            {{l.Prefix}}{{l.DisplayName}}
                          </option>
                        </select>
                        <!--<label class="margin-bottom-0px margin-top-5px">{{AdmissionService.ProviderName}}</label>-->
                      </div>
                      <!--<div class="col-md-2 margin-top-3px">
                        <button 
                                type="button" (click)="ServiceProvider()"
                                class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3">
                          <i class="fas fa-ellipsis-h"></i>
                        </button>                        
                      </div>-->
                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right padding-left-0px margin-top-3px">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Charge</label>
                      </div>
                      <div class="col-md-5 padding-right-0px">
                        <input type="number" class="form-control" placeholder="Service Charge"
                               id="OPService.ProviderCost"
                               [(ngModel)]="OPService.ProviderCost"
                               name="OPService.ProviderCost" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                               maxlength="30" #Location="ngModel" required>                       
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row" hidden>
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right padding-left-0px margin-top-3px">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Treatment Category</label>
                      </div>
                      <div class="col-md-5 padding-right-0px">
                        <CodeTypeValue CodeType="ATCTY" id="TrCat" class="form-control"
                                       [(ngModel)]="OPService.TreatmentCategory" SelectedValue=""
                                       name="TrCat">
                        </CodeTypeValue>                       
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right padding-left-0px margin-top-3px">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Remarks</label>
                      </div>
                      <div class="col-md-6 padding-right-0px">
                        <input type="text" class="form-control" placeholder="Remarks"
                               id="OPService.Remarks"
                               [(ngModel)]="OPService.Remarks"
                               name="OPService.Remarks" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                               maxlength="30" #Location="ngModel">
                        <!--<CodeTypeValue CodeType="TRRE" SelectedValue="">
                        </CodeTypeValue>-->

                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" (click)="close_dialog(OPService)" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-left-auto">Save</button>
            <!--<button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-left-3px margin-right-3px">Completed</button>-->
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-auto font-size-13px" (click)="activeModal.close('Close click')">Cancel</button>


          </div>
        </form>
      </div>
    </div>
  </div>
</div>
